import { RedirectPage } from '@/components/redirect-page'

import '@/config/branchio'
import '@/config/mixpanel'
import {
  ROUTE_CLAIM,
  ROUTE_CLUBS,
  ROUTE_CLUB_MANAGEMENT,
  ROUTE_CREATE_PASSWORD,
  ROUTE_SIGNUP_LANDING,
  ROUTE_DASHBOARD,
  ROUTE_EVENTS,
  ROUTE_EXTERNAL_CLAIM,
  ROUTE_EXTERNAL_CREATE_PASSWORD,
  ROUTE_EXTERNAL_LOGIN,
  ROUTE_EXTERNAL_SIGNUP,
  ROUTE_EXTERNAL_THIS_ACCOUNT_IS_ALREADY_TAKEN,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_HOME,
  ROUTE_LIFETIME,
  ROUTE_LOGIN,
  ROUTE_HARD_SUBSCRIBE,
  ROUTE_MAIN,
  ROUTE_NEW_MATCH,
  ROUTE_PASSWORD_SECURITY,
  ROUTE_TWO_FACTOR,
  ROUTE_TWO_FACTOR_LEGACY,
  ROUTE_PLAY,
  ROUTE_PLAYERS,
  ROUTE_PLAYER_PROFILE,
  ROUTE_PREMIUM_LOGIN,
  ROUTE_PRIVACY_POLICY,
  ROUTE_PROFILE,
  ROUTE_RESET_PASSWORD_TOKEN,
  ROUTE_REST_PASSWORD,
  ROUTE_SIGNUP,
  ROUTE_SUBSCRIPTION,
  ROUTE_TERMS,
  ROUTE_VERIFY,
  ROUTE_VERIFY_EMAIL,
  ROUTE_CONNECTIONS,
  ROUTE_PREFERENCES,
  ROUTE_REDEEM_CODE,
  ROUTE_VERIFY_PHONE,
  ROUTE_DUPR_REPLAY,
  ROUTE_MATCH,
  ROUTE_CLAIM_BENEFIT,
  ROUTE_MY_BENEFITS,
  ROUTE_COACH_PROFILE,
  ROUTE_MY_COACHING,
  ROUTE_WEB_SESSION,
  ROUTE_MEMBERSHIP_REQUIRED,
  ROUTE_OAUTH_AUTHORIZE,
  ROUTE_CONNECT,
} from '@/constants/Routes'

import { Login } from '@/pages/auth'
import { Claim } from '@/pages/auth/pages/claim'
import { ClaimDetail } from '@/pages/auth/pages/claim-detail'
import { CreatePassword } from '@/pages/auth/pages/create-password'
import { ForgotPassword } from '@/pages/auth/pages/forgot-password'
import { ResetPassword } from '@/pages/auth/pages/reset-password'
import { ResetPasswordWithToken } from '@/pages/auth/pages/reset-password-token'
import { SignUp } from '@/pages/auth/pages/sign-up'
import { SignUpStart } from '@/pages/auth/pages/sign-up-start'
import { VerifyEmail } from '@/pages/auth/pages/verify-email'

import { Club, ClubDetail, ClubEdit, CreateNewEvent, InvitePlayer, MyClubs } from '@/pages/club'
import { ClubEditMatch } from '@/pages/club/pages/club-edit-match'
import { ClubNewMatch } from '@/pages/club/pages/club-new-match'
import { ClubManagement } from '@/pages/club-management'
import { ClaimBenefit, MyBenefits } from '@/pages/benefits'
import { BenefitsRouteGate } from '@/pages/benefits/components/BenefitsRouteGate'
import { CoachProfile, MyCoaching } from '@/pages/coach'
import { BracketDetail, Event, EventDetail, MyEvents } from '@/pages/event'
import { AddBracket } from '@/pages/event/pages/add-bracket'
import { BracketDiagram } from '@/pages/event/pages/bracket-diagram'
import { CreateNewAnnoucement } from '@/pages/event/pages/create-annoucement'
import { EditBracket } from '@/pages/event/pages/edit-bracket'
import { EditEvent } from '@/pages/event/pages/edit-event'
// import { SeedMatches } from '@/pages/event/pages/seed-matches'
import {
  ClaimDetails,
  ClaimYourAccount,
  ExternalCreatePassword,
  ExternalLoginPage,
  ExternalSignUp,
  ExternalThisAccountAlreadyTaken,
} from '@/pages/external'
import { Landing } from '@/pages/home'

import { Lifetime } from '@/pages/lifetime'
import { NotFound } from '@/pages/notfound'
import { Performance } from '@/pages/performance'
import { NewMatch } from '@/pages/performance/new-match'
import { Play } from '@/pages/play'
import { Player, PlayerProfile } from '@/pages/player'

import { PrivacyPolicy } from '@/pages/privacy-policy'
import { Terms } from '@/pages/terms'
import { ChangePassword, PasswordSecurity, Profile, TwoFactor } from '@/pages/user'
import { UserVerifyEmail } from '@/pages/user/pages/user-verify-email'

import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/remote-config'

import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom'

import { SubscriptionPage } from './pages/user/pages/subscription'
import { HardSubscribe } from './pages/auth/pages/hard-subscribe'
import ConnectionsPage from './pages/user/pages/connections'
import Preferences from './pages/user/pages/preferences'
import { ExternalRedeemPage } from '@/pages/external/redeem/ExternalRedeemPage.tsx'
import { WebSessionPage } from '@/pages/web-session/WebSessionPage'
import { OAuthAuthorizePage, ConnectResolverPage } from '@/pages/oauth'
import VerifyPhonePage from './pages/verify-phone/VerifyPhonePage'
import { useEffect } from 'react'
import { DuprReplay } from './pages/replay/Replay'
import { MatchPage } from './pages/match/MatchPage'
import { MembershipRequiredPage } from './pages/membership/MembershipRequiredPage'

function Redirect() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(ROUTE_DASHBOARD)
  }, [navigate])
  return <></>
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTE_MAIN} element={<Outlet />}>
        <Route index element={<Landing />} />
      </Route>
      <Route path={ROUTE_PREFERENCES} element={<Preferences />} />
      <Route path={`${ROUTE_EXTERNAL_LOGIN}/:partnerId`} element={<ExternalLoginPage mode="standard" />} />
      <Route path={`${ROUTE_PREMIUM_LOGIN}/`} element={<ExternalLoginPage mode="premium" />} />
      <Route path={`${ROUTE_REDEEM_CODE}/`} element={<ExternalRedeemPage />} />
      <Route path={`${ROUTE_MEMBERSHIP_REQUIRED}/`} element={<MembershipRequiredPage />} />
      <Route path={ROUTE_WEB_SESSION} element={<WebSessionPage />} />
      <Route path={ROUTE_OAUTH_AUTHORIZE} element={<OAuthAuthorizePage />} />
      <Route path={ROUTE_CONNECT} element={<ConnectResolverPage />} />
      <Route path={`${ROUTE_EXTERNAL_CLAIM}/:partnerId`} element={<ClaimYourAccount />} />
      <Route path={`${ROUTE_EXTERNAL_CLAIM}/:playerId/:partnerId`} element={<ClaimDetails />} />
      <Route path={`${ROUTE_EXTERNAL_SIGNUP}/:partnerId`} element={<ExternalSignUp />} />
      <Route
        path={`${ROUTE_EXTERNAL_THIS_ACCOUNT_IS_ALREADY_TAKEN}/:playerId/:partnerId`}
        element={<ExternalThisAccountAlreadyTaken />}
      />
      <Route path={`${ROUTE_EXTERNAL_CREATE_PASSWORD}/:partnerId`} element={<ExternalCreatePassword />} />
      <Route path={ROUTE_LOGIN} element={<Outlet />}>
        <Route index element={<Login />} />
      </Route>
      <Route path={ROUTE_CLAIM} element={<Outlet />}>
        <Route index element={<Claim />} />
        <Route path=":claimId" element={<ClaimDetail />} />
      </Route>
      <Route path={ROUTE_SIGNUP} element={<Outlet />}>
        {/* Email-first entry: ask for an email and send a signup link. */}
        <Route index element={<SignUpStart />} />
        <Route path={ROUTE_CREATE_PASSWORD} element={<CreatePassword />} />
        {/* The signup link lands here; the full form redeems the token and builds the request. */}
        <Route path={ROUTE_SIGNUP_LANDING} element={<SignUp />} />
      </Route>
      <Route path={ROUTE_FORGOT_PASSWORD} element={<Outlet />}>
        <Route index element={<ForgotPassword />} />
        <Route path={ROUTE_VERIFY_EMAIL} element={<VerifyEmail />} />
        <Route path={ROUTE_REST_PASSWORD} element={<ResetPassword />} />
      </Route>

      <Route path={ROUTE_HARD_SUBSCRIBE} element={<HardSubscribe />} />

      <Route path={ROUTE_HOME} element={<Redirect />} />

      <Route path={ROUTE_DASHBOARD} element={<Outlet />}>
        <Route index element={<Performance />} />
        <Route path={ROUTE_NEW_MATCH} element={<NewMatch />} />
        <Route path={ROUTE_PLAYERS} element={<Player />} />
        <Route path={ROUTE_PLAY} element={<Play />} />
        <Route path={`${ROUTE_PLAYER_PROFILE}/:playerId`} element={<PlayerProfile />} />
        <Route path={`${ROUTE_PLAYER_PROFILE}/:playerId/profile`} element={<RedirectPage />} />
        <Route path={ROUTE_MATCH} element={<MatchPage />} />
        <Route path={ROUTE_CLUBS} element={<Outlet />}>
          <Route index element={<Club />} />
          <Route path="my" element={<MyClubs />} />
          <Route path=":clubId" element={<ClubDetail />} />
          <Route path=":clubId/edit" element={<ClubEdit />} />
          <Route path=":clubId/add-organizers" element={<InvitePlayer isAddOrganizer />} />
          <Route path=":clubId/match/new" element={<ClubNewMatch />} />
          <Route path=":clubId/match/edit/:matchId" element={<ClubEditMatch />} />
          <Route path=":clubId/invite-player" element={<InvitePlayer />} />
          <Route path=":clubId/create-event" element={<CreateNewEvent />} />
          <Route path=":clubId/event/:eventId/edit-draft" element={<CreateNewEvent />} />
        </Route>
        <Route path={ROUTE_CLUB_MANAGEMENT} element={<ClubManagement />} />
        {/* Behind one layout gate rather than five checks: the member's side and the coach's side
            of a claim are the same feature, and a build where only one of them existed would make
            claims nobody could answer. See BenefitsRouteGate for why the routes stay registered. */}
        <Route element={<BenefitsRouteGate />}>
          <Route path={ROUTE_MY_BENEFITS} element={<MyBenefits />} />
          <Route path={ROUTE_CLAIM_BENEFIT} element={<ClaimBenefit />} />
          <Route path={`${ROUTE_CLAIM_BENEFIT}/:grantId`} element={<ClaimBenefit />} />
          <Route path={ROUTE_COACH_PROFILE} element={<CoachProfile />} />
          <Route path={ROUTE_MY_COACHING} element={<MyCoaching />} />
        </Route>
        <Route path={`${ROUTE_DASHBOARD}/club`} element={<Outlet />}>
          <Route path=":clubId/info" element={<RedirectPage />} />
          <Route path=":clubId/event/:eventId/info" element={<RedirectPage />} />
          <Route path=":clubId/event/:eventId/bracket/:bracketId" element={<RedirectPage />} />
        </Route>
        <Route path={ROUTE_EVENTS} element={<Outlet />}>
          <Route index element={<Event />} />
          <Route path="my" element={<MyEvents />} />
          <Route path=":eventId" element={<EventDetail />} />
          <Route path=":eventId/edit" element={<EditEvent />} />
          <Route path=":eventId/bracket/add" element={<AddBracket />} />
          <Route path=":eventId/create-announcement" element={<CreateNewAnnoucement />} />
          <Route path=":eventId/info" element={<RedirectPage />} />
          <Route path=":eventId/bracket/:bracketId" element={<BracketDetail />} />
          <Route path=":eventId/bracket/:bracketId/diagram" element={<BracketDiagram />} />
          <Route path=":eventId/bracket/:bracketId/edit" element={<EditBracket />} />
        </Route>
        <Route path={ROUTE_CONNECTIONS} element={<ConnectionsPage />} />
        <Route path={ROUTE_PROFILE} element={<Profile />} />
        <Route path={ROUTE_VERIFY_PHONE} element={<VerifyPhonePage />} />
        <Route path={ROUTE_SUBSCRIPTION} element={<SubscriptionPage />} />
        {/* Password & Security is one settings entry with two sub-sections: the index is the
            change-password form, `two-factor` is MFA management. The old top-level two-factor
            address redirects so existing links still land. */}
        <Route path={ROUTE_PASSWORD_SECURITY} element={<PasswordSecurity />}>
          <Route index element={<ChangePassword />} />
          <Route path="two-factor" element={<TwoFactor />} />
        </Route>
        <Route path={ROUTE_TWO_FACTOR_LEGACY} element={<Navigate to={ROUTE_TWO_FACTOR} replace />} />
        <Route path={`${ROUTE_DUPR_REPLAY}/:batchId`} element={<DuprReplay />} />
      </Route>
      <Route path={ROUTE_PRIVACY_POLICY} element={<PrivacyPolicy />} />
      <Route path={ROUTE_TERMS} element={<Terms />} />
      <Route path={ROUTE_VERIFY} element={<UserVerifyEmail />} />
      <Route path={ROUTE_RESET_PASSWORD_TOKEN} element={<ResetPasswordWithToken />} />
      <Route path={ROUTE_LIFETIME} element={<Lifetime />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
